"use client";
import React from "react";
import { useDispatch } from "react-redux";
import { useRouter } from "next/navigation";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
} from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import {
  showLoading,
  hideLoading,
} from "@/lib/redux-toolkit/features/setting/settingSlice";
import { apiGetProfile, apiGetToken } from "@/lib/actions";
import { setSession } from "@/lib/auth";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";

const FormSchema = z.object({
  email: z
    .string()
    .email({ message: "Hãy nhập đúng email. (VD:example@gmail.com)" }),
  password: z.string().min(3, {
    message:
      "Mật khẩu phải có từ 8 đến 16 kí tự! bao gồm chữ thường, chữ hoa, số, kí tự đặc biệt. Ví dụ: 12345Cc@",
  }),
});
const listField = [
  { key: "email", value: "Email" },
  { key: "password", value: "Mật khẩu" },
];

export default function Page() {
  const dispatch = useDispatch();
  const router = useRouter();

  const form = useForm<z.infer<typeof FormSchema>>({
    resolver: zodResolver(FormSchema),
    defaultValues: {},
  });

  type FormValues = z.infer<typeof FormSchema> & { domain?: string };

  const onSubmit = async (values: z.infer<typeof FormSchema>) => {
    dispatch(showLoading());

    let newValue: FormValues = { ...values, domain: window.location.hostname };
    const tokenRes = await apiGetToken(newValue);

    if (tokenRes.data) {
      await setSession(`${process.env.COOKIE_PREFIX}-token`, tokenRes.data);
      const userRes = await apiGetProfile();
      if (userRes.data) {

        const userCookie = await setSession(
          `${process.env.COOKIE_PREFIX}-auth`,
          userRes.data
        );


        if (userCookie) {
          await router.push("/");
        } else {
          form.setError("email", {
            type: "manual",
            message:
              "Không thể đăng nhập. Lỗi máy khách. Hãy liên hệ với quản trị viên để được xử lý. ",
          });
        }
      }
    } else {
      for (var key in tokenRes.errors) {
        var obj = tokenRes.errors[key];
        let field_key = obj.field_key;
        let field_key_arr = field_key.split("[");
        let field_name = "";

        if (Array.isArray(field_key_arr)) {
          field_name = field_key_arr[0];
        } else {
          if (typeof field_key_arr === "string") {
            field_name = field_key;
          }
        }

        if (field_name !== "") {
          for (var i = 0; i < listField.length; i++) {
            let value = obj.field_value.replace(
              listField[i].key,
              listField[i].value
            );
            form.setError(field_name as keyof z.infer<typeof FormSchema>, {
              type: "manual",
              message: value,
            });
          }
        } else {
          form.setError("email", {
            type: "manual",
            message:
              obj.field_value ??
              "Lỗi hệ thống. Hãy liên hệ với quản trị viên để được xử lý.",
          });
        }
      }
    }

    dispatch(hideLoading());
  };
  return (
    <div className="flex min-h-svh w-full items-center justify-center p-6 md:p-10">
      <div className="w-full max-w-sm">
        <div className="flex flex-col gap-6">
          <Card>
            <CardHeader>
              <CardDescription>
                Nhập email và mật khẩu để đăng nhập vào hệ thống chia sẻ cơ sở
                vật chất
              </CardDescription>
            </CardHeader>
            <CardContent>
              <Form {...form}>
                <form onSubmit={form.handleSubmit(onSubmit)}>
                  <div className="flex flex-col gap-6">
                    <div className="grid gap-2">
                      <FormField
                        control={form.control}
                        name="email"
                        render={({ field }) => (
                          <FormItem>
                            <FormLabel>
                              Email
                              <strong className="text-red-500">*</strong>
                            </FormLabel>
                            <FormControl>
                              <Input
                                type="email"
                                placeholder="example@gmail.com"
                                {...field}
                              />
                            </FormControl>
                            <FormMessage />
                          </FormItem>
                        )}
                      />
                    </div>
                    <div className="grid gap-2">
                      <FormField
                        control={form.control}
                        name="password"
                        render={({ field }) => (
                          <FormItem>
                            <FormLabel className="flex items-center">
                              Mật khẩu
                              <strong className="text-red-500">*</strong>
                              {/*<a*/}
                              {/*  href={"/reset-password"}*/}
                              {/*  className="ml-auto inline-block text-sm underline-offset-4 hover:underline"*/}
                              {/*>*/}
                              {/*  Bạn quên mật khẩu?*/}
                              {/*</a>*/}
                            </FormLabel>
                            <FormControl>
                              <Input
                                type="password"
                                placeholder="example@gmail.com"
                                {...field}
                              />
                            </FormControl>
                            <FormMessage />
                          </FormItem>
                        )}
                      />
                    </div>
                    <Button type="submit" className="w-full">
                      Đăng nhập
                    </Button>
                  </div>
                  {/*<div className="mt-4 text-center text-sm">*/}
                  {/*  Bạn chưa có tài khoản?{" "}*/}
                  {/*  <a*/}
                  {/*    href={"/register"}*/}
                  {/*    className="underline underline-offset-4"*/}
                  {/*  >*/}
                  {/*    Đăng ký ngay*/}
                  {/*  </a>*/}
                  {/*</div>*/}
                </form>
              </Form>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}
